import slugify from '../helpers/formatters/slugify';

const weekDays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];

export default class ContentAdmin {
  // TABLE FUNCTIONS
  static generateTable(parent, data) {
    const groups = data.grupos;

    groups.forEach((group) => {
      if (group.classificacao) {
        const table = document.importNode(document.querySelector('#points-table').content, true);
        table.firstElementChild.classList.add(`${slugify(group.grupo.nome)}`);

        table.querySelector('.title').textContent = group.grupo.nome;
        group.classificacao.forEach((row, index) => {
          ContentAdmin.generateTeamsRow(table.querySelector('.teams-body'), row, index);
          ContentAdmin.generatePointsRow(table.querySelector('.points-body'), row);
        });

        document.querySelector(parent).appendChild(table);
      }
    });
  }

  static generateTeamsRow(parent, data, index) {
    const row = document.importNode(document.querySelector('#points-teams').content, true);
    row.querySelector('.championship__teams-ranking').textContent = index + 1;
    row.querySelector('.championship__table-teams-team').textContent = data.equipe;
    row.querySelector('.championship__table-teams-acronym').textContent = data.sigla;
    if (row.querySelector('svg.flag use')) {
      row.querySelector('svg.flag use').setAttribute('xlink:href', `#flag-${slugify(data.equipe)}`);
    } else if (row.querySelector('img.flag')) {
      let teamShield = data.escudo.svg;
      if (!teamShield) {
        teamShield = 'https://s.glbimg.com/es/sde/f/organizacoes/escudo_default_65x65.png';
      }
      row.querySelector('img.flag').setAttribute('src', teamShield);
    }
    parent.appendChild(row);
  }

  static generatePointsRow(parent, data) {
    const row = document.importNode(document.querySelector('#points-row').content, true);
    const lastGames = row.querySelector('.championship__team-games');
    const td = row.querySelectorAll('.table-cell');

    td[0].textContent = data.pontos === null || data.pontos === undefined ? '-' : data.pontos;
    td[1].textContent = data.jogos === null || data.jogos === undefined ? '-' : data.jogos;
    td[2].textContent = data.vitorias === null || data.vitorias === undefined ? '-' : data.vitorias;
    td[3].textContent = data.derrotas === null || data.derrotas === undefined ? '-' : data.derrotas;
    td[4].textContent = data.sets_ganhos === null || data.sets_ganhos === undefined ? '-' : data.sets_ganhos;
    td[5].textContent = data.sets_perdidos === null || data.sets_perdidos === undefined ? '-' : data.sets_perdidos;
    td[6].textContent = data.pontos_pro === null || data.pontos_pro === undefined ? '-' : data.pontos_pro;
    td[7].textContent = data.pontos_contra === null || data.pontos_contra === undefined ? '-' : data.pontos_contra;

    data.ultimos_jogos.forEach((game) => {
      const lastEl = document.createElement('li');
      lastEl.classList.add(game === 'v' ? 'championship__team-game--win' : 'championship__team-game--loose');
      lastGames.appendChild(lastEl);
      // lastGames.appendChild(document.createElement('li'))
    });

    parent.appendChild(row);
  }

  static generateSchedule(parent, groupData) {
    const scheduleTemplate = document.importNode(document.querySelector('#game-schedule').content, true);
    const sliderID = `schedule-${slugify(groupData.grupo.nome)}`;

    const schedule = scheduleTemplate.querySelector('.table--schedule');
    schedule.setAttribute('data-slider', sliderID);
    schedule.querySelector('.carousel__nav').setAttribute('data-navigation', sliderID);

    const titleList = schedule.querySelector('.carousel__title-list');
    titleList.setAttribute('data-slide-list', sliderID);

    const scheduleContent = scheduleTemplate.querySelector('.carousel__content-list');
    scheduleContent.setAttribute('data-slide-list', sliderID);

    groupData.rodadas.forEach((gamesData) => {
      titleList.insertAdjacentHTML('beforeend', `<li><h2 class="carousel__title">${gamesData.rodada.replace(/-/g, '/')}</h2></li>`);

      const gamePhaseWrap = document.createElement('li');
      gamesData.jogos.forEach((gameData) => {
        ContentAdmin.generateGame(gameData, gamePhaseWrap);
      });
      scheduleContent.appendChild(gamePhaseWrap);
    });

    document.querySelector(parent).appendChild(scheduleTemplate);
  }

  // PLAYOFF FUNCTIONS
  static generatePlayOffs(parent, data) {
    const section = document.createElement('section');
    section.classList.add('section-playoff');

    section.insertAdjacentHTML('beforeend', `<h2 class="title">${data.grupo.nome}</h2></li>`);

    data.rodadas.forEach((gamesData) => {
      gamesData.jogos.forEach((gameData) => {
        ContentAdmin.generateGame(gameData, section);
      });
    });
    document.querySelector(parent).appendChild(section);
  }

  static generateGame(gameData, parent) {
    const gameTemplate = document.importNode(document.querySelector('#game').content, true);
    const game = gameTemplate.querySelector('.game');
    if (gameData.data !== undefined && gameData.data !== '' && gameData.data !== null) {
      const gameDate = new Date(gameData.data);
      const gameHour = (gameData.data.split('T')[1]).split(':')[0];
      game.querySelector('.game-timestamp--bold').textContent = `${weekDays[gameDate.getDay()]} ${gameDate.getDate()}/${(gameDate.getMonth() + 1).toString().padStart(2, '0')}/${gameDate.getUTCFullYear()}`;
      game.querySelector('.game-timestamp--semibold').textContent = `${gameHour}:${gameDate.getMinutes().toString().padStart(2, '0')}`;
    } else {
      game.querySelector('.game-timestamp--semibold').textContent = 'data indefinida';
    }
    game.querySelector('.game-city').textContent = gameData.sede;
    if (gameData.time_casa) {
      game.querySelector('.game-placccard__team--a').textContent = gameData.time_casa.sigla;
      if (game.querySelector('.game-placccard__flag--a use')) {
        game.querySelector('.game-placccard__flag--a use')
            .setAttribute('xlink:href', `#flag-${slugify(gameData.time_casa.nome)}`);
      } else if (game.querySelector('.game-placccard__flag--a')) {
        game.querySelector('.game-placccard__flag--a').setAttribute('src', gameData.time_casa.escudo.svg);
      }
    } else {
      game.querySelector('.game-placccard__team--a').textContent = 'IND';
    }
    if (gameData.time_visitante) {
      game.querySelector('.game-placccard__team--b').textContent = gameData.time_visitante.sigla;
      if (game.querySelector('.game-placccard__flag--b use')) {
        game.querySelector('.game-placccard__flag--b use')
            .setAttribute('xlink:href', `#flag-${slugify(gameData.time_visitante.nome)}`);
      } else if (game.querySelector('.game-placccard__flag--b')) {
        game.querySelector('.game-placccard__flag--b').setAttribute('src', gameData.time_visitante.escudo.svg);
      }
    } else {
      game.querySelector('.game-placccard__team--b').textContent = 'IND';
    }

    if (gameData.placar.casa !== 0 || gameData.placar.visitante !== 0) {
      game.querySelector('.game-placcard__result--team-a').textContent = gameData.placar.casa;
      game.querySelector('.game-placcard__result--team-b').textContent = gameData.placar.visitante;
    }

    if (gameData.sets[0].pontos_time_casa !== null) {
      const setList = document.createElement('ul');
      setList.classList.add('game-sets');
      gameData.sets.forEach((set) => {
        if (set.pontos_time_casa && set.pontos_time_visitante) {
          if (set.pontos_time_casa > set.pontos_time_visitante) {
            setList.insertAdjacentHTML('beforeend', `<li class="game-set"><b>${set.pontos_time_casa}</b> - ${set.pontos_time_visitante}</li>`);
          } else {
            setList.insertAdjacentHTML('beforeend', `<li class="game-set">${set.pontos_time_casa} - <b>${set.pontos_time_visitante}</b></li>`);
          }
        }
      });
      game.appendChild(setList);
    }

    parent.appendChild(gameTemplate);
  }
}



// WEBPACK FOOTER //
// local_static/templates/volei/2018/assets/scripts/modules/ContentAdmin.js